<img *ngIf="data.icon" [src]="data.icon.url" [alt]="data.icon.altText" />
<div
	class="obg-m-snackbar-content-wrap"
	[attr.test-id]="data.type ? 'snackbar-container-' + data.type : 'snackbar-container'"
	[attr.data-test-id]="data.type ? 'snackbar-container-' + data.type : 'snackbar-container'"
>
	<div class="obg-m-snackbar-content">
		<span [innerHTML]="data.message" test-id="snackbar-content" data-test-id="snackbar-content"></span>
		<button
			*ngIf="!data.buttons?.length && data.action"
			mat-flat-button
			(click)="onDismissWithAction()"
			test-id="snackbar-dismiss-button"
			color="primary"
		>
			{{ data.action }}
		</button>
	</div>
	<div
		*ngIf="data.buttons?.length || (data.doNotShowAgainButton && data.id && !data.dismissibleDuration)"
		class="obg-m-snackbar-buttons"
	>
		<button
			*ngIf="data.doNotShowAgainButton && data.id && !data.dismissibleDuration"
			mat-flat-button
			(click)="doNotShowAgain()"
			test-id="snackbar-do-not-show-button"
			color="primary"
		>
			{{ "general.do-not-show-again" | translate }}
		</button>
		<a
			*ngFor="let button of data.buttons"
			mat-flat-button
			[obgRouteLink]="{ url: button.url }"
			(click)="button.handler()"
			[target]="button.target"
			color="primary"
			>{{ button.text }}</a
		>
	</div>
</div>
<span
	*ngIf="data.buttons?.length || data.dismissible"
	class="ico-close"
	test-id="snackbar-close-button"
	(click)="onDismiss()"
></span>
<ng-container *ngIf="!!data.dismissibleDuration">
	<span
		*ngIf="dismissibleCountDown$ | async as dismissibleCountDown; else dismissableDurationClose"
		class="obg-m-snackbar-countdown"
	>
		{{
			dismissibleCountDownTranslationKey
				| jurisdiction
				| translate: { dismissibleCountDown: dismissibleCountDown }
		}}
	</span>
	<ng-template #dismissableDurationClose>
		<div class="obg-m-snackbar-countdown-dismiss">
			<button
				*ngIf="data.doNotShowAgainButton && data.id"
				mat-flat-button
				(click)="doNotShowAgain()"
				test-id="snackbar-do-not-show-button"
				color="primary"
			>
				{{ "general.do-not-show-again" | translate }}
			</button>
			<span>{{ dismissibleMessageTranslationKey | jurisdiction | translate }}</span>
			<span class="ico-close" test-id="dismissable-snackbar-close-button" (click)="onDismissWithAction()"></span>
		</div>
	</ng-template>
</ng-container>
